import { render } from "./ChargebeeUpsellMarketingDomainsItem.vue?vue&type=template&id=f16105d4&scoped=true"
import script from "./ChargebeeUpsellMarketingDomainsItem.vue?vue&type=script&lang=js"
export * from "./ChargebeeUpsellMarketingDomainsItem.vue?vue&type=script&lang=js"

import "./ChargebeeUpsellMarketingDomainsItem.vue?vue&type=style&index=0&id=f16105d4&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f16105d4"]])

export default __exports__